import actions from './actions';

const {
  GET_BLOG_VIDEO_BEGIN, GET_BLOG_VIDEO_SUCCESS, GET_BLOG_VIDEO_FAILED,
  ADD_BLOG_VIDEO_BEGIN, ADD_BLOG_VIDEO_SUCCESS, ADD_BLOG_VIDEO_FAILED,
  UPDATE_BLOG_VIDEO_BEGIN, UPDATE_BLOG_VIDEO_SUCCESS, UPDATE_BLOG_VIDEO_FAILED,
  DELETE_BLOG_VIDEO_BEGIN, DELETE_BLOG_VIDEO_SUCCESS, DELETE_BLOG_VIDEO_FAILED
} = actions;

const initState = {
  total: 0,
  currentPage: 1,
  pageLimit: 50,
  videos: [],
  loading: false,
  error: null,
};


const BlogVideoReducer = (state = initState, action) => {
  const { type, data, err } = action;
  switch (type) {
    case GET_BLOG_VIDEO_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case GET_BLOG_VIDEO_SUCCESS:
      return {
        ...state,
        total: data.totalBlogVideo,
        videos: data.blogVideos,
        currentPage: data.currentPage || 1,
        pageLimit: data.pageLimit || state.pageLimit,
        loading: false,
      };
    case GET_BLOG_VIDEO_FAILED:
      return {
        ...state,
        error: err,
        loading: false,
      };
    case ADD_BLOG_VIDEO_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case ADD_BLOG_VIDEO_SUCCESS:
      return {
        ...state,
        total: state.total + 1,
        videos: data,
        loading: false,
      };
    case ADD_BLOG_VIDEO_FAILED:
      return {
        ...state,
        error: err,
        loading: false,
      };
    case UPDATE_BLOG_VIDEO_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case UPDATE_BLOG_VIDEO_SUCCESS:
      return {
        ...state,
        videos: data,
        loading: false,
      };
    case UPDATE_BLOG_VIDEO_FAILED:
      return {
        ...state,
        error: err,
        loading: false,
      };
    case DELETE_BLOG_VIDEO_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case DELETE_BLOG_VIDEO_SUCCESS:
      return {
        ...state,
        total: state.total - 1,
        videos: data,
        loading: false,
      };
    case DELETE_BLOG_VIDEO_FAILED:
      return {
        ...state,
        error: err,
        loading: false,
      };
    default:
      return state;
  }
};
export default BlogVideoReducer;